import { keccak256, type Address } from 'viem';

/**
 * Invite codes: 8 characters of Crockford base32 (no I, L, O or U) taken from the first 40 bits of keccak256 of the
 * member's address. Short enough to read out, and it says nothing about the address. A code is only ever looked up
 * among bound members (the indexer, or the Bound logs), so a made-up code resolves to nobody; if two members ever
 * shared a code, the one who bound first keeps it.
 */
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export const INVITE_CODE_LENGTH = 8;

export function inviteCode(address: Address): string {
  let bits = BigInt(keccak256(address.toLowerCase() as Address).slice(0, 12)); // 0x + 10 hex = 40 bits
  let out = '';
  for (let i = 0; i < INVITE_CODE_LENGTH; i++) {
    out = ALPHABET[Number(bits & 31n)] + out;
    bits >>= 5n;
  }
  return out;
}

/** What a person typed or a link carried, as a code: case, spaces and dashes ignored, O→0 and I/L→1. Null if it can't be one. */
export function normalizeInviteCode(raw: string): string | null {
  const s = raw
    .trim()
    .toUpperCase()
    .replace(/[\s-]/g, '')
    .replace(/O/g, '0')
    .replace(/[IL]/g, '1');
  return s.length === INVITE_CODE_LENGTH && [...s].every((c) => ALPHABET.includes(c)) ? s : null;
}
